// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_2Vpko","label":"_2vB9H"};